import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useLocation, useNavigate } from "react-router";

const TOKEN_KEY = "id_token";

const tokenContext = createContext<string | null>(null);
export const useTokenContext = () => useContext(tokenContext);

export function TokenProvider({ children }: { children: React.ReactNode }) {
  const { pathname, search, hash } = useLocation();
  const hashParams = useMemo(() => new URLSearchParams(hash.slice(1)), [hash]);

  // since this hash value is provided by an external service,
  // we never have to worry about it changing throughout app lifetime;
  // and in fact, since the hash is cleaned, we couldn't if we wanted to
  const [value] = useState(hashParams.get(TOKEN_KEY));

  const navigate = useNavigate();
  // ensure authorization token is wiped from URL hash
  useEffect(() => {
    if (hashParams.has(TOKEN_KEY)) {
      hashParams.delete(TOKEN_KEY);
      const hashString = hashParams.size ? `#${hashParams}` : "";
      navigate(`${pathname}${search}${hashString}`, { replace: true });
    }
  }, [hashParams, navigate, pathname, search, value]);

  return (
    <tokenContext.Provider value={value}>{children}</tokenContext.Provider>
  );
}
